import React from 'react';
import { useLocation } from 'react-router-dom';
import useTransitionalNavigate from '../../hooks/useTransitionalNavigate';

interface LinkProps {
  to: string,
  state?: any,
  children: React.ReactNode,
  onClick?: React.MouseEventHandler,
  className?: string
}

/**
 * Utilizes startTransition to avoid white screen flashes when transitioning between pages using a components.
 */
function Link({ to, state, onClick, children, className } : LinkProps) {
  const { search } = useLocation();
  const navigate = useTransitionalNavigate();
  const fullPath = search ? `${to}${search}` : to;

  const isAbsoluteUrl = (url: string = '') => url.indexOf('http://') === 0 || url.indexOf('https://') === 0;

  const handleLinkClick = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    if (onClick) {
      onClick(e);
    }

    const absoluteUrl = isAbsoluteUrl(fullPath);
    if (absoluteUrl) {
      window.location.href = to;
    } else if (state) {
      navigate(fullPath, { state });
    } else {
      navigate(fullPath);
    }
  };

  return <a onClick={handleLinkClick} href={fullPath} className={className}>{children}</a>;
}

export default Link;
